import React from "react";
import WhyChooseCarousel, {
  toWhyChooseReasons,
} from "../../components/WhyChooseCarousel";
import { whyChooseContent } from "./foodSafetyContent";

/* Same strip the Home page uses, so the question reads identically wherever it
   is asked. These reasons come from this page's approved document as bare
   lines, so they borrow the shared illustrations positionally. */
const FoodSafetyWhyChoose = () => (
  <WhyChooseCarousel
    id="food-safety-why-choose-heading"
    title={whyChooseContent.title}
    reasons={toWhyChooseReasons(whyChooseContent.reasons)}
    tone="light"
  />
);

export default FoodSafetyWhyChoose;
